import { ThemeTypes } from './themeManage';

const antdTheme = {
  activeShadow: 'none',
  controlOutline: 0
  // colorSplit: 'none',
};

const uiThemeTokens = {
  [ThemeTypes.red]: {
    primary: '#E1251B',
    primaryHover: '#C3150C',
    textPrimary: '#070E32',
    borderColor: '#D9D9D9',
  },
  [ThemeTypes.blue]: {
    primary: '#E1251B',
    primaryHover: '#C3150C',
    textPrimary: '#070E32',
    borderColor: '#D9D9D9',
  },
  [ThemeTypes.yellow]: {
    primary: '#FFD000',
    primaryHover: '#E6BD00',
    textPrimary: '#070E32',
    borderColor: '#D9D9D9',
  },
  [ThemeTypes.dark]: {
    primary: '#E1251B',
    primaryHover: '#C3150C',
    textPrimary: '#070E32',
    borderColor: '#D9D9D9',
  },
};

const createBaseComponents = (themeType: ThemeTypes) => {
  const token = uiThemeTokens[themeType];
  return {
    Button: {
      defaultShadow: 'none',
      primaryShadow: 'none',
      controlHeightLG: 48,
      colorError: '#E1251B',
      colorErrorHover: '#C3150C',
      colorErrorBorderHover: '#C3150C',
      textHoverBg: 'none',
      colorBgTextActive: 'none',
      textTextColor: token.textPrimary,
      textTextActiveColor: token.primary,
      textTextHoverColor: token.primary,
      borderRadiusLG: 4,
      paddingInlineLG: 20,
      colorPrimaryHover: token.primaryHover,
    },
    Input: {
      activeShadow: 'none',
      activeBorderColor: token.primary,
      hoverBorderColor: token.primary,
    },
    Tabs: {
      itemSelectedColor: token.primary,
      itemActiveColor: token.primary,
      itemHoverColor: token.primary,
      inkBarColor: token.primary,
    },
    Modal: {
      titleColor: token.textPrimary,
      colorIcon: 'rgba(0, 3, 20, 0.45)',
      colorIconHover: token.textPrimary,
    },
    InputNumber: {
      activeBorderColor: 'none',
      hoverBorderColor: 'none',
      activeShadow: 'inherit',
    },
    Anchor: {
      fontSize: '16px',
      lineHeight: 2,
      colorSplit: 'rgba(7, 14, 50, 0.2)',
    },
    Form: {
      itemMarginBottom: 13,
      labelColor: 'rgba(7, 14, 50, 0.8)',
      verticalLabelPadding: '0 0 2px',
      labelRequiredMarkColor: '#ff4d4f',
    },
    Tooltip: {
      colorBgSpotlight: '#070E32',
      colorText: '#FFF',
    },
    Steps: {
      colorTextDescription: 'rgba(7, 14, 50, 0.5)',
      colorText: '#000000',
      colorPrimary: '#575B6B',
    },
    Card: {
      boxShadowTertiary: 'none',
    },
  };
};

export default {
  [ThemeTypes.red]: {
    token: {
      ...antdTheme,
      colorPrimary: uiThemeTokens[ThemeTypes.red].primary,
    },
    components: createBaseComponents(ThemeTypes.red),
  },
  [ThemeTypes.blue]: {
    token: {
      ...antdTheme,
      colorPrimary: uiThemeTokens[ThemeTypes.blue].primary,
    },
    components: createBaseComponents(ThemeTypes.blue),
  },
  [ThemeTypes.yellow]: {
    token: {
      ...antdTheme,
      colorPrimary: uiThemeTokens[ThemeTypes.yellow].primary,
    },
    components: createBaseComponents(ThemeTypes.yellow),
  },
  [ThemeTypes.dark]: {
    token: {
      ...antdTheme,
      colorPrimary: uiThemeTokens[ThemeTypes.dark].primary,
    },
    components: createBaseComponents(ThemeTypes.dark),
  },
};
